"use strict";
/*
 * 8x8 Confidential & Proprietary || Copyright 2025 8x8, Inc. or its affiliates. All Rights Reserved.
 *  _____      _____
 * |  _  |    |  _  |
 *  \ V /__  __\ V /   ___ ___  _ __ ___
 *  / _ \\ \/ // _ \  / __/ _ \| '_ ` _ \
 * | |_| |>  <| |_| || (_| (_) | | | | | |
 * \_____/_/\_\_____(_)___\___/|_| |_| |_|
 *
 * @License https://www.8x8.com/terms-and-conditions/software-development-kit-license-agreement
 * @Author Comanici Paul
 * @Date 2025/08/27
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.INSTANCE_ID = exports.OWN_DATA_TYPES = exports.RECEIVE_DATA_TYPES = exports.INTERNAL_MESSAGE_TYPE = void 0;
const INTERNAL_MESSAGE_TYPE = "sdk-message";
exports.INTERNAL_MESSAGE_TYPE = INTERNAL_MESSAGE_TYPE;
const RECEIVE_DATA_TYPES = {
    SDK_MESSAGE: INTERNAL_MESSAGE_TYPE,
    FILE_TRANSFER: "file-transfer",
};
exports.RECEIVE_DATA_TYPES = RECEIVE_DATA_TYPES;
// these are the types that the SDK will use to send data in cases where we do extra processing
// like file transfer completion
const OWN_DATA_TYPES = {
    FILE_TRANSFER_COMPLETE: "file-transfer-complete",
};
exports.OWN_DATA_TYPES = OWN_DATA_TYPES;
const INSTANCE_ID = "partner-instance";
exports.INSTANCE_ID = INSTANCE_ID;
//# sourceMappingURL=data.js.map